import { render, staticRenderFns } from "./module-permission.vue?vue&type=template&id=eb4a1c46&scoped=true"
import script from "./module-permission.vue?vue&type=script&lang=ts"
export * from "./module-permission.vue?vue&type=script&lang=ts"
import style0 from "./module-permission.vue?vue&type=style&index=0&id=eb4a1c46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4a1c46",
  null
  
)

export default component.exports